import { render, staticRenderFns } from "./SetorProfile.vue?vue&type=template&id=2fede9d9"
import script from "./SetorProfile.vue?vue&type=script&lang=js"
export * from "./SetorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports